import React from 'react';
import cn from 'clsx';
import { string } from 'prop-types';
import VerticalNav from '../VerticalNav/index.jsx';

/**
 * DropDownNav component.
 */
const DropDownNav = ({
  className,
  menuItems,
  ariaLabel,
  domId
}) => /*#__PURE__*/React.createElement("div", {
  className: cn('drop-down-nav', className)
}, /*#__PURE__*/React.createElement(VerticalNav, {
  domId: domId,
  ariaLabel: ariaLabel,
  menuItems: menuItems
}));
DropDownNav.defaultProps = {
  ariaLabel: '',
  className: '',
  domId: '',
  menuItems: []
};
DropDownNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Descriptive label for the navigation */
  ariaLabel: string,
  /** Additional class names to add to the component root. */
  className: string,
  /** ID for the navigation DOM element */
  domId: string,
  /** Menu items */
  menuItems: VerticalNav.propTypes.menuItems
} : {};
export default DropDownNav;